export enum TimezoneSelectionDataHooks {
  TIMEZONE_SELECTION = 'timezone-selection',
  TIMEZONE_DROPDOWN = 'timezone-dropdown',
  TIMEZONE_TEXT = 'timezone-text',
}
